/**
 * CustomScriptControls — universal "Custom code" panel shown on every
 * module instance editor. Writes `custom_script` into the instance config,
 * which `ScriptEmbed` (rendered by ModularPage next to every module) runs
 * verbatim on the public page — including real <script> tags, unlike the
 * sanitised rich-text/HTML-embed surfaces elsewhere in the CMS.
 *
 * Deliberately unsanitised: only Master Admins can reach this field (it
 * lives behind the same auth as every other CMS editor), so it's a trusted
 * escape hatch for analytics pixels, chat widgets and similar embeds that
 * require JS — not a general content field.
 */
import { Textarea } from "@/components/ui/textarea";
import { Code2 } from "lucide-react";

export default function CustomScriptControls({ config = {}, onChange }) {
  return (
    <div className="pt-4 border-t" data-testid="custom-script-controls">
      <div className="text-xs font-medium mb-2 text-muted-foreground uppercase tracking-wide flex items-center gap-1.5">
        <Code2 className="h-3.5 w-3.5" />
        Custom code (advanced)
      </div>
      <Textarea
        value={config.custom_script || ""}
        onChange={(e) => onChange?.({ custom_script: e.target.value })}
        placeholder='<script>...</script> or any embed snippet (e.g. chat widget, analytics pixel)'
        rows={4}
        className="font-mono text-xs"
        data-testid="custom-script-textarea"
      />
      <p className="text-xs text-muted-foreground mt-2">
        Runs on the public page wherever this module is placed — &lt;script&gt; tags execute,
        unlike other CMS content fields. Only paste code from sources you trust.
      </p>
    </div>
  );
}
